<form [formGroup]="usrPwdForm" class="password-form" (ngSubmit)="updatePassword()">
  <mat-form-field class="pwd-field" id="oldPwdField">
    <mat-label>Current password</mat-label>
    <input matInput formControlName="usrPwdOld" [type]="hideOldPwd() ? 'password' : 'text'" />
    <button
      mat-icon-button
      matSuffix
      (click)="toggleHidePwd($event, hideOldPwd)"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hideOldPwd()">
      <mat-icon>
        {{ hideOldPwd() ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field class="pwd-field" id="newPwdField">
    <mat-label>New password</mat-label>
    <input
      formControlName="usrPwdNew"
      appPasswordStrength
      matInput
      [type]="hideNewPwd() ? 'password' : 'text'" />
    <button
      mat-icon-button
      matSuffix
      (click)="toggleHidePwd($event, hideNewPwd)"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hideNewPwd()">
      <mat-icon>
        {{ hideNewPwd() ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>
    @if (usrPwdNew?.invalid) {
      <mat-error class="error-messages">
        {{ pwdNewErrorMsg() }}
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="pwd-field" id="confPwdField">
    <mat-label>Confirm password</mat-label>
    <input formControlName="usrPwdConfirm" matInput [type]="hideConfPwd() ? 'password' : 'text'" />
    <button
      mat-icon-button
      matSuffix
      (click)="toggleHidePwd($event, hideConfPwd)"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hideConfPwd()">
      <mat-icon>
        {{ hideConfPwd() ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </button>
    @if (noPwdMatch()) {
      <mat-error>New Password must match.</mat-error>
    }
  </mat-form-field>
  <div>
    <button mat-raised-button color="primary" type="submit" [disabled]="usrPwdForm.invalid">
      Change Password
    </button>
  </div>
</form>
